import Vue from 'vue';
import { MutationTree } from 'vuex';
import { Operation } from '@/manager/sync/operation.model';
import { State } from '@/manager/sync/store/state';
import { OperationTypeInterface } from '@/manager/sync/operationType.interface';

export interface Mutations {
    setOperationList: {list: Operation[]};
    setOperationTypeList: {list: OperationTypeInterface[]};
}

export const mutations: MutationTree<State> = {
    setOperationList: (state, payload) => {
        state.list = payload;
    },
    setOperationTypeList: (state, payload) => {
        state.operationTypeList = payload;
    },
    setKpiList: (state, payload) => {
        state.kpiList = payload;
    },
    updateOperation: (state, payload) => {
        const index = state.list.map( (item: any) => item.id ).indexOf( payload.id );
        if (index > -1) {
            const participant = state.list[ index ];
            const newParticipant = Object.assign({}, participant, payload);
            Vue.set( state.list, index, newParticipant );
        }
    },
};
